export default __webpack_public_path__ + "static/media/carbonara-supreme.4b2c18a7.jpg";